import { OverlayProvider } from '@react-aria/overlays';
import { Modal as ModalBase } from './Modal';
import { SidePanel } from './SidePanel';
import { Title } from './Title';
import { Header } from './header';
import { Body } from './body';
import { Footer } from './footer';
import { Close } from './close';
import { ModalContext } from './contexts';
export const Modal = Object.assign(ModalBase, {
    Provider: OverlayProvider,
    Title,
    SidePanel,
    Header,
    Body,
    Footer,
    Close,
    Context: ModalContext,
});
